<template>
  <v-dialog v-model="isShow" @click:outside="close" width="600">
    <v-card>
      <v-card-title style="text-align: left; font-weight: bold">
        Xác nhận thông tin lớp học
      </v-card-title>
      <v-card-text >
        <div class="d-flex flex-column align-center mb-4">
          <span>Vui lòng kiểm tra thông tin và xác nhận.</span>
          <span>Bạn không được sửa lại sau khi đã xác nhận!</span>
        </div>
        <v-row style="padding: 0 32px">
          <v-col cols="5" class="pb-0 pr-0">Học sinh:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pb-0 pl-0">{{student.name}}</v-col>
          <v-col cols="5" class="pb-0 pr-0">Lịch học:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pb-0 pl-0">
            <span v-for="(item, index) in data.cases" :key="'itemCase' + index">
              <span style="font-weight: bold">{{item.nameDayOfWeek}}</span>
              <span style="font-weight: normal"> ({{item.fromTime}} - {{item.toTime}}) </span>
              <span v-if="index < data.cases.length - 1">, </span>
            </span>
          </v-col>
          <v-col cols="5" class="pb-0 pr-0">Giáo viên:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pb-0 pl-0">{{teacher.name}}</v-col>
          <v-col cols="5" class="pr-0">Ngày khai giảng:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pl-0">{{formatDateSlash(data.startDate)}}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-center mb-4">
        <v-btn color="#ED185A" style="color: white" @click="submit">Xác nhận</v-btn>
        <v-btn color="#AEAEB2" style="color: white" @click="close">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TutorSortClassRepository from '@/services/TutorSortClassRepository';
import { mapState } from 'vuex';
import { UPDATE_CARE_TAG } from '@/modules/student_care/constant/constant';

export default {
  name: 'ConfirmCreateClassPopup',
  props: {
    studentCareInfo: {
      type: Object,
      required: true,
    },
    studentProductId: {
      type: Number,
      required: true,
    },
    teacher: {
      type: Object,
      required: true,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    student: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('student_care', ['listProgram']),
  },
  methods: {
    async submit() {
      const loading = this.$loading.show();
      const program = this.listProgram.find((e) => e.id === _.get(this.student, 'curriculum.id', null));
      // eslint-disable-next-line no-unused-vars
      let abbrCode = null;
      if (program) {
        // eslint-disable-next-line radix
        abbrCode = _.get(program.program_groups.find((el) => el.id === parseInt(_.get(this.student, 'productProgramGroupIds[0]', ''))), 'abbr_code', '');
      }
      const payload = {
        ...this.data,
        abbrCode,
        schedules: this.data.cases,
        studentProductsId: [this.studentProductId],
        typeCurriculum: 'online',
      };
      const result = await TutorSortClassRepository.storeClass2(payload);
      if (result.success) {
        const payloadUpdate = {
          care_id: this.studentCareInfo.id,
          lms_core_user_id: this.studentCareInfo.lms_core_user_id,
          curriculum_id: this.studentCareInfo.curriculum_id,
          move_to: UPDATE_CARE_TAG.DA_XEP_LOP,
        };
        TutorSortClassRepository.updateCareTag(payloadUpdate);
        const classInPayload = {
          courseName: result.data.classCode,
          courseIntroduce: result.data.classCode,
        };
        const responseClassin = await TutorSortClassRepository.createClassinClass(classInPayload);
        if (responseClassin.success) {
          const responseSyncStudent = await TutorSortClassRepository.addMultipleStudent({
            classId: result.data.classId,
          });
          if (responseSyncStudent.success) {
            this.$swal({
              text: 'Tạo lớp học mới thành công',
              icon: 'success',
              toast: true,
              timer: 4000,
              showConfirmButton: false,
              position: 'top',
            });
          } else {
            this.$swal({
              text: responseSyncStudent.errors.message ?? responseSyncStudent.message ?? 'Lớp học chưa được đồng bộ ClassIn!',
              icon: 'error',
              toast: true,
              timer: 4000,
              showConfirmButton: false,
              position: 'top',
            });
          }
        } else {
          this.$swal({
            text: `Có lỗi khi tạo lớp Classin, ${responseClassin.errors.message}`,
            icon: 'warning',
            toast: true,
            timer: 6000,
            showConfirmButton: false,
            position: 'top',
          });
        }
        this.doneCreateClass();
      } else {
        this.$swal({
          text: `Tạo lớp mới thất bại: ${result.errors.message}`,
          toast: true,
          icon: 'error',
          showConfirmButton: false,
          timer: 4000,
          position: 'top',
          timerProgressBar: true,
        });
      }
      loading.hide();
    },
    doneCreateClass() {
      this.$emit('finish-create-class');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
